export enum ProviderConnectionStatusEnum {
  Unknown = 'Unknown',
  LoggedIn = 'LoggedIn',
  ConnectionLost = 'ConnectionLost',
  LoggedOut = 'LoggedOut'
}
